import { render, staticRenderFns } from "./Satellite.vue?vue&type=template&id=bc68fa30&scoped=true"
import script from "./Satellite.vue?vue&type=script&lang=js"
export * from "./Satellite.vue?vue&type=script&lang=js"
import style0 from "./Satellite.vue?vue&type=style&index=0&id=bc68fa30&prod&scoped=true&lang=sass"
import style1 from "./Satellite.vue?vue&type=style&index=1&id=bc68fa30&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc68fa30",
  null
  
)

export default component.exports